
import { Tooltip } from "components/components/tooltip/tooltip";
import i18n from "components/i18n/i18n";
import template from "./tileElement.hbs";
import "./tileElement.scss";


export class TileElement extends HTMLElement {

  constructor() {
    super();
    this.innerHTML = template({
      width: this.getAttribute("width"),
      mdwidth: this.getAttribute("mdwidth"),
      lgwidth: this.getAttribute("lgwidth"),
      title: this.getAttribute("title"),
      subtitle: this.getAttribute("subtitle"),
      style: this.getAttribute("style")
    });
  }

  private disconnectedCallback() {
  }


  set data(v: Date) {
  }
}

export function initTiletWebComponent() {
  window.customElements.define("s6-tile", TileElement);
}
